import { Grid } from "@mui/material";
import { FormikProps } from "formik";

import { FormikCounselorSelect } from "@/common/components/counselor-select/FormikCounselorSelect";
import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { useTranslation } from "@/translations";

import { TakeoverHistoryFilterValues } from "../TakeoverHistoryPanel.types";

interface Props {
  formik: FormikProps<TakeoverHistoryFilterValues>;
}

/** Filter bar: from/till date window and the "abgegeben von" / "übernommen von" Bearbeiter:in dropdowns.
 *  Filters apply live as the form values change. */
export function TakeoverHistoryFilterBar({ formik }: Props) {
  const { t } = useTranslation();

  return (
    <Grid container columnSpacing={2} rowSpacing={1}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormikDatePicker
          fieldName="fromDate"
          label={t("takeover.history.filter.from")}
          formik={formik}
          clearable={false}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormikDatePicker fieldName="toDate" label={t("takeover.history.filter.to")} formik={formik} clearable />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormikCounselorSelect
          fieldName="givenUpByCounselorId"
          label={t("takeover.history.filter.givenUpBy")}
          formik={formik}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormikCounselorSelect
          fieldName="takenOverByCounselorId"
          label={t("takeover.history.filter.takenOverBy")}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
